var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygraphFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9903 50.8488H21.2759L37.2857 10H44.0002L27.9903 50.8488Z",
    fill: "#009DE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7625 34.289L24.8767 41.651L16 19.7308H22.9014L26.157 29.1627L27.7625 34.289Z",
    fill: "var(--favicon-highlight, white)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygraphFavicon);
export default __webpack_public_path__ + "static/media/polygraph_favicon.5177a4642a945c8e9ce968ba83c72df5.svg";
export { ForwardRef as ReactComponent };